module.exports = __webpack_public_path__ + "static/img/88017D_2_3_R_20190321_fit.cb43f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/88017D_2_3_R_20190321_fit.png
// module id = iBQ8
// module chunks = 0